import { fetchIt, FetchItTag } from "./fetchIt";
import { fetchResultCasting } from "./fetchResultCasting";

export async function fetchItJson<SuccessT, NonSuccessT>(
  tag: FetchItTag,
  // eslint-disable-next-line @typescript-eslint/prefer-readonly-parameter-types
  ...input: Parameters<typeof fetch>
) {
  // eslint-disable-next-line @typescript-eslint/prefer-readonly-parameter-types, @typescript-eslint/no-unsafe-return
  return fetchIt(tag, ...input).then(async (result) => {
    const contentType = result.response.headers.get("content-type");

    if (
      contentType !== null &&
      contentType.indexOf("application/json") !== -1
    ) {
      return result.response.json().then((parsed) => {
        return fetchResultCasting<SuccessT, NonSuccessT>(result, parsed);
      });
    } else {
      // for DELETE or other non-json responses
      return fetchResultCasting<SuccessT, NonSuccessT>(result, result.response.json());
    }
  });
}
